import { Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as castArray from 'lodash/castArray';
import { Observable } from 'rxjs';

import { NotificationsService } from '../services/notifications.service';
import { Notification } from '../state/notifications.interface';

dayjs.extend(relativeTime);

export enum ShowCloseOptions {
	TRUE = 'true', // Close icons are always shown
	AUTO = 'auto', // Close icons are shown if the notification has no duration (default)
	FALSE = 'false' // Close icons are never shown (only recommended if you are also setting a duration)
}

@Component({
	selector: 'ac-notifications',
	templateUrl: './notifications.component.html',
	styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {


	@Input() public channel: string | string[];
	@Input() public showTime: boolean = false;
	@Input() public showClose: ShowCloseOptions = ShowCloseOptions.AUTO;
	public notifications$: Observable<Notification[]>;

	constructor(private notificationsService: NotificationsService) { }

	public ngOnInit(): void {
		this.notifications$ = this.channel
			? this.notificationsService.getVisibleNotificationsByChannel$(castArray(this.channel))
			: this.notificationsService.getAllVisibleNotifications$();
	}

	public dismiss(id: string): void {
		this.notificationsService.dismissNotification(id);
	}

	public getFromNow(timestamp: number): string {
		return dayjs(timestamp).fromNow();
	}
}
